import { lookupService } from "@/services/public/lookup.service";
import i18n from "@/i18n";
import { sharedHelper, alertHelper } from "@/utils";
import { lookupModel } from "@/models/api/lookup.model";

export const state = {
    companyDdl: [],
    departmentDdl: [],
    candidateJobDdl: [],
    locationDdl: [],
    panelTypeDdl: [],
};

export const LOOKUP_MODULE = "public/lookup";

// ACTIONS
export const LOOKUP_COMPANY = 'lookupCompany';
export const LOOKUP_DEPARTMENT = "lookupDepartment";
export const LOOKUP_CANDIDATE_JOB = "lookupCandidateJob";
export const LOOKUP_LOCATION = "lookupLocation";
export const LOOKUP_PANEL_TYPE = "lookupPanelType";

// MUTATIONS
const COMPANY_LOOKUP = "companyLookup";
const DEPARTMENT_LOOKUP = "departmentLookup";
const CANDIDATE_JOB_LOOKUP = "candidateJobLookup";
const LOCATION_LOOKUP = "locationLookup";
const PANEL_TYPE_LOOKUP = "panelTypeLookup";

export const actions = {
    [LOOKUP_LOCATION]({ commit }) {
        return lookupService.getLocations()
            .then((result) => {
                commit(LOCATION_LOOKUP, { result });
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                return null;
            });
    },
    [LOOKUP_PANEL_TYPE]({ commit }) {
        return lookupService.getPanelTypes()
            .then((result) => {
                commit(PANEL_TYPE_LOOKUP, { result });
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                return null;
            });
    },
    [LOOKUP_COMPANY]({ commit }, searchWords = []) {
        return lookupService.getCompanies(searchWords)
            .then((result) => {
                commit(COMPANY_LOOKUP, { result });
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
                return null;
            });
    },
    [LOOKUP_DEPARTMENT]({ commit }) {
        lookupService
            .getDepartments()
            .then((result) => {
                commit(DEPARTMENT_LOOKUP, { result });
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
            });
    },
    [LOOKUP_CANDIDATE_JOB]({ commit }) {
        lookupService
            .getCandidateJobs()
            .then((result) => {
                commit(CANDIDATE_JOB_LOOKUP, { result });
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
            });
    },
};

export const mutations = {
    [COMPANY_LOOKUP](state, { result }) {
        let array = [];
        if (result.success) {
            result.data.forEach((item) => {
                array.push(lookupModel(item));
            })
            state.companyDdl = array;
        } else {
            state.companyDdl = [];
        }
    },
    [DEPARTMENT_LOOKUP](state, { result }) {
        let array = [];
        if (result.success) {
            result.data.forEach((item) => {
                array.push(lookupModel(item));
            })
            state.departmentDdl = array;
        } else {
            state.departmentDdl = [];
        }
    },
    [CANDIDATE_JOB_LOOKUP](state, { result }) {
        let array = [];
        if (result.success) {
            result.data.forEach((item) => {
                array.push(lookupModel(item));
            })
            state.candidateJobDdl = array;
        } else {
            state.candidateJobDdl = [];
        }
    },
    [LOCATION_LOOKUP](state, { result }) {
        let array = [];
        if (result.success) {
            result.data.forEach((item) => {
                array.push(lookupModel(item));
            })
            state.locationDdl = array;
        } else {
            state.locationDdl = [];
        }
    },
    [PANEL_TYPE_LOOKUP](state, { result }) {
        let array = [];
        if (result.success) {
            result.data.forEach((item) => {
                array.push(lookupModel(item));
            })
            state.panelTypeDdl = array;
        } else {
            state.panelTypeDdl = [];
        }
    },
};